import React from 'react';
import HeaderNavigationStyle from './HeaderNavigationStyle';
const HeaderNavigation = ({ children }) => (React.createElement(HeaderNavigationStyle, null, children));
export default HeaderNavigation;
//# sourceMappingURL=HeaderNavigation.js.map